import { lazy } from "react";
import Loadable from "app/components/Loadable";

const CategoryList = Loadable(lazy(() => import("./CategoryList")));
const CategoryAdd = Loadable(lazy(() => import("./CategoryAdd")));

const CategoryRoutes = [
  { path: "/asset/category", element: <CategoryList /> },
  { path: "/asset/category/:mode/:id", element: <CategoryAdd /> },
];

export default CategoryRoutes;
